/**
 * Contact Us API endpoints
 */
import { api } from './baseApi';

export interface ContactUs {
  id: number;
  email: string;
  phone: string;
  address: string;
  created_at: string;
  updated_at: string;
}

export interface ContactUsMessage {
  id: number;
  full_name: string;
  email: string;
  message: string;
  created_at: string;
}

interface ContactResponse {
  success: boolean;
  data: ContactUs;
  message?: string;
}

interface ContactMessagesResponse {
  success: boolean;
  data: ContactUsMessage[];
  message?: string;
}

export interface UpdateContactData {
  email?: string;
  phone?: string;
  address?: string;
}

export const contactApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getContact: builder.query<ContactResponse, void>({
      query: () => '/dashboard/contact-us/',
      providesTags: ['Contact'],
    }),
    updateContact: builder.mutation<ContactResponse, UpdateContactData>({
      query: (data) => ({
        url: '/dashboard/contact-us/',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Contact'],
    }),
    getContactMessages: builder.query<ContactMessagesResponse, void>({
      query: () => '/dashboard/contact-us/messages/',
      providesTags: ['ContactMessages'],
    }),
  }),
});

export const {
  useGetContactQuery,
  useUpdateContactMutation,
  useGetContactMessagesQuery,
} = contactApi;

